<div class="password-modal" *ngIf="isOpen">
  <div class="password-modal-content">
    <div class="password-modal-header">
      <h3>Confirm your Signature password to continue</h3>
      <span class="close-icon" (click)="closeModal()">&times;</span>
    </div>
    <div class="password-modal-body">
      <div class="password-input-container">
        <label>Signature Password</label>
        <input type="password" 
               [(ngModel)]="signaturePassword" 
               placeholder="Enter your signature password"
               [class.error]="!!errorMessage"
               (keyup.enter)="confirmPassword()" />
        <div class="error-message" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>
      </div>
      <p class="password-hint">You need to enter your Signature password to confirm this change.</p>
    </div>
    <div class="password-modal-footer">
      <button class="confirm-btn" 
              (click)="confirmPassword()" 
              [disabled]="!signaturePassword">
              Confirm
      </button>
      <button class="cancel-btn" 
              (click)="closeModal()">
        Cancel
      </button>
    </div>
  </div>
</div> 